module.exports = __webpack_public_path__ + "static/media/mdi_vertical_align_bottom.4ab41f7b.svg";